function updateDynamicPrices(priceHolderClass, dynamicPriceClass) {
    const priceHolder = document.querySelector(`${priceHolderClass} [data-product-price]`);
    const comparePriceHolder = document.querySelector(`${priceHolderClass} [data-compare-price]`);
    
    if (priceHolder) {
        const newPrice = priceHolder.innerHTML;
        const comparePrice = comparePriceHolder.innerHTML;

        const dynamicPriceElements = document.querySelectorAll(dynamicPriceClass);

      if (comparePrice) {
        dynamicPriceElements.forEach(element => {
          element.innerHTML = `<span class="product__price--compare">${comparePrice}</span> ${newPrice}`
        })
      } else {
        dynamicPriceElements.forEach(element => {
            element.innerHTML = newPrice;
        });
      }
        
    }
}


updateDynamicPrices('.tcw-price-data-holder-1', '.tcw-dynamic-price-1');

updateDynamicPrices('.tcw-price-data-holder-2', '.tcw-dynamic-price-2');

updateDynamicPrices('.tcw-price-data-holder-3', '.tcw-dynamic-price-3');

updateDynamicPrices('.tcw-price-data-holder-4', '.tcw-dynamic-price-4');

updateDynamicPrices('.tcw-price-data-holder-5', '.tcw-dynamic-price-5');
